import { Type } from '@sinclair/typebox';
import { baseCommandSchema } from "./shared.mjs";
export const selectPaymentMethodCommandSchema = Type.Intersect([
    baseCommandSchema,
    Type.Object({
        command: Type.Literal('selectPaymentMethod'),
        /**
         * Note that in the case of Adyen this is the id of our PaymentMethod, and not the
         * id of the selected Adyen (sub) payment method.
         */
        paymentMethodId: Type.String(),
    }),
]);
export const addCodeCommandSchema = Type.Intersect([
    baseCommandSchema,
    Type.Object({
        command: Type.Literal('addCode'),
        code: Type.String(),
    }),
]);
export const removeCodeCommandSchema = Type.Intersect([
    baseCommandSchema,
    Type.Object({
        command: Type.Literal('removeCode'),
        code: Type.String(),
    }),
]);
//# sourceMappingURL=payment.js.map